/**
 * @generated SignedSource<<160464095b26570200b79c58338d1564>>
 * @relayHash 2e10897c6459f1a7f9ad5addb0741793
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 2e10897c6459f1a7f9ad5addb0741793

import { ConcreteRequest } from 'relay-runtime';
export type postalCodeSelectorGetPostalCodesQuery$variables = {
  countryIsoCode: string;
  keyword?: string | null;
};
export type postalCodeSelectorGetPostalCodesQuery$data = {
  readonly displayablePostalCodes: ReadonlyArray<{
    readonly city: string;
    readonly label: string;
    readonly value: string;
  }>;
};
export type postalCodeSelectorGetPostalCodesQuery = {
  response: postalCodeSelectorGetPostalCodesQuery$data;
  variables: postalCodeSelectorGetPostalCodesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "countryIsoCode"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "keyword"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "countryIsoCode",
        "variableName": "countryIsoCode"
      },
      {
        "kind": "Variable",
        "name": "keyword",
        "variableName": "keyword"
      }
    ],
    "concreteType": "DisplayablePostalCode",
    "kind": "LinkedField",
    "name": "displayablePostalCodes",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "label",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "value",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "city",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "postalCodeSelectorGetPostalCodesQuery",
    "selections": (v1/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "postalCodeSelectorGetPostalCodesQuery",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "id": "2e10897c6459f1a7f9ad5addb0741793",
    "metadata": {},
    "name": "postalCodeSelectorGetPostalCodesQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "2b4729a2a738a20941b439a349f1300e";

export default node;
